import { useSettings } from "master";

export const useRefundPolicy = ({ load = false, key = "" }) => {
  const { settingsInfo } = useSettings({ load, key });
  return {
    settingsInfo,
  };
};
